import { themeColors } from "../Theme/themeColors";
import { createMuiTheme } from "@material-ui/core/styles";
import { forEach, merge } from "lodash";
import themeOptions from "../Theme/themeOptions";

function createMatxThemes() {
  let themes = {};

  forEach(themeColors, (value, key) => {
    themes[key] = createMuiTheme(merge({}, themeOptions, value));
  });
  return themes;
}

const themes = createMatxThemes();

const SettingsLayout = {
    leftSidebar: {
      show: true,
      mode: 'compact',
      theme: 'slateDark2',
      bgImgURL: '/assets/images/sidebar/sidebar-bg-dark.jpg'
    },
    topbar: {
      show: true,
      fixed: true,
      theme: 'eazydiner'
    }
}

export const LayoutSettings = {
  activeLayout: "layout1",
  activeTheme: "eazydiner",
  perfectScrollbar: true,

  themes: themes,
  SettingsLayout
};
